import React, { useCallback } from 'react';
import { useController } from 'react-hook-form';
import FieldStatus from '../field-status';
import TagInput from '../tag-input';
import { TAG_INPUT_FIELD_PROP_TYPES } from './types';

const defaultRules = {};

const TagInputField = ({
  name = null,
  control,
  rules = defaultRules,
  onChange = Function.prototype,
  onBlur = Function.prototype,
  ...otherProps
}) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (newValue) => {
      field.onChange(newValue);
      onChange(newValue);
    },
    [field, onChange]
  );

  const handleBlur = useCallback(() => {
    field.onBlur();
    onBlur();
  }, [field, onBlur]);

  return (
    <React.Fragment>
      <TagInput
        {...otherProps}
        name={field.name}
        tags={field.value}
        invalid={fieldState.invalid}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
    </React.Fragment>
  );
};

TagInputField.propTypes = TAG_INPUT_FIELD_PROP_TYPES;

export default TagInputField;
